export default angular
  .module('doxy.common.filters.dDuration', [])
  .filter('dDuration', function () {
    function to00(num) {
      return num < 10 ? '0' + num : num;
    }

    return function (ms) {
      if (!ms) {
        return ms;
      }

      const time = parseInt(ms);

      return [
        to00(Math.floor((time / (1000 * 60 * 60)) % 24)),
        to00(Math.floor((time / (1000 * 60)) % 60)),
        to00(Math.floor((time / 1000) % 60)),
      ].join(':');
    };
  }).name;
